export default "__VITE_ASSET__CC_xKPba__"